import React, {FC} from "react";
import {Captcha} from "./Captcha";
import {useAuth} from "../auth/AuthContext";
import {AccountsAPI} from "../../accounts-api/accounts-api";
import {useNavigate} from "react-router";
const Humans = React.lazy(() => import("./HumansAreComing"));


export const CaptchaRetry: FC = () => {
  const navigate = useNavigate();
  const {user, loading} = useAuth();
  if (loading) {
    return null;
  }

  const initAccount = async (token: string) => {
    if (!user) {
      return;
    }
    const idToken = await user.getIdToken();
    await AccountsAPI.initAccount( {uid: user.uid, idToken, captchaToken: token});
    navigate("/authenticated")
  };
  
  return <div className="flex flex-col">
    <div className="mb-5">
      <Humans />
    </div>
    <Captcha tokenCallback={initAccount} visible={true} mode={"challenge"}/>
  </div>
}
